export const FILE_PATH_SEPARATOR = '/';

export const DownloadStates = {
  DOWNLOADING: 'downloading',
  READY: 'ready',
  ERROR: 'error',
};

export const UpdateAttributeStates = {
  IN_PROGRESS: 'in_progress',
  ERROR: 'error',
  DONE_SUCCESS: 'done_success',
};

export const MoveStates = {
  IN_PROGRESS: 'in_progress',
  ERROR: 'error',
  DONE_SUCCESS: 'done_success',
};

export const FileUploadEvents = {
  OPEN_FILE_UPLOAD_DIALOG: 'open_file_upload_dialog',
  NAVIGATE_TO_FOLDER: 'navigate_to_folder',
};

export const FileGalleryEvents = {
  REFRESH_SEARCH: 'refresh_search',
};

export const FILE_GALLERY_ITEM_META_HEIGHT_PX = 40;

export const FileDescriptionTypes = {
  VIDEO: 'Video',
};

export const FILE_PANEL_MAX_ITEMS_DISPLAY = 100;

export enum FileTaskTypes {
  UPDATE,
}

export enum FileTaskStatus {
  IN_PROGRESS,
  DONE_SUCCESS,
  ERROR,
}

export enum TaskNotificationReason {
  ADDED,
  UPDATED,
  REMOVED,
}

export enum FileType {
  VIDEO = 'Video',
  DOCUMENT = 'Document',
  IMAGE = 'Image',
  FONT = 'Font',
  ARCHIVE = 'Archive',
  AUDIO = 'Audio',
}

/**
 * The default task for dam uploads
 */
export const DAM_FILE_UPLOAD_DEFAULT_TASK = 'piivo-dam-upload';
